import React, { useContext } from 'react'
import { css, theme } from '@bdfx/fukit'
import { AuditContext } from '../providers/AuditProvider'
import { Audit } from '@bdfx/audit-api/types'
import trans from '../trans'
import { plausible } from '../../common/tracking'

type PricingFoxCtaBannerProps = {
    headlineText?: JSX.Element
    text?: JSX.Element
}

export default function PricingFoxCtaBanner({headlineText = null, text = null}: PricingFoxCtaBannerProps) {

    const [data]: [Audit] = useContext(AuditContext)

    const handleClick = () => {
        plausible("pf_banner_click", { props: { id: data?.id, email: data?.notify_email } })
    }

    return (
        <Anchor onClick={handleClick} href="https://pricing-fox.cz/?utm_source=audit_pricing&utm_medium=app" target="_blank">
            <Wrapper>
                <div>
                    <img src={`https://cdn.bdfx.cz/app/pf/img/lisaci/fox_idea.png`} alt="Aktivujte Pricing Fox na 30 dni zdarma" height="115" width="70" />
                </div>
                <TextWrapper>
                    <div>
                        {headlineText ? 
                            <p className='first'>{headlineText}</p> 
                        : <>
                             <p className='first'>{text}</p>
                        </>}
                    </div>
                    <div>
                        {headlineText ? 
                        <>
                            <p className='second'>{trans("pf_cta_banner_line1")}</p>
                            <p className='second'>{trans("pf_cta_banner_line2")}</p>
                        </> : 
                        <>
                            <p className='second'>{trans("pf_cta_banner_line2")}</p>
                        </>}
                    </div>
                </TextWrapper>
            </Wrapper>
        </Anchor>
    )
}

const Wrapper = css("article")({
    display: "flex",
    padding: "20px",
    margin: "0 auto",
    alignItems: "center",
    fontWeight: "normal",
    width: "fit-content",
    borderRadius: "999em",
    background: "white",
    border: "1px solid " + theme.green,
    position: "relative",
    
    boxShadow: "2px 2px 10px 0px rgb(0 0 0 / 30%)",
    transition: "all 0.1s",
    "&:hover": {
        boxShadow: "1px 1px 1px 1px rgb(0 0 0 / 20%)",
        transform: "translate3d(1px,1px,0)",
        background: "#f0fff0",
    },

    "img": {
        maxHeight: "100%",
        width: "auto",
        display: "block",
    },
})

const TextWrapper = css("div")({
    display: "flex",
    flexDirection: "column",
    rowGap: "2px",
    justifyContent: "space-around",
    padding: "10px",
    textAlign: "center",
    fontWeight: "normal",
    whiteSpace: "nowrap",
    " p": {
        margin: "0",
        padding: "0",
        lineHeight: "1.2em",
    },
    " p.first": {
        fontSize: "26px",
        fontWeight: "bold",
    },
    " p.second": {
        fontSize: "20px",
        color: "#333",
    },
})

const Anchor = css("a")({
    display: "inline-block",
    margin: "0 auto",
    alignItems: "center",
    width: "fit-content",
    ":hover, :active, :focus": {
        textDecoration: "none",
    }
})